var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import cl from 'clsx';
import GroupedHeading from './Heading';
import GroupedItem from './Item';
export const DescriptionList = forwardRef((_a, ref) => {
    var { className, children } = _a, rest = __rest(_a, ["className", "children"]);
    return (React.createElement("dl", Object.assign({}, rest, { ref: ref, className: cl('cds-dropdown__list', className) }), children));
});
DescriptionList.Heading = GroupedHeading;
DescriptionList.Item = GroupedItem;
DescriptionList.displayName = 'Dropdown.Menu.DescriptionList';
export default DescriptionList;
